import { BaseModel } from './BaseModel';

export class ValueRanged extends BaseModel {
  hydrate(data, source) {
    const isApi = source === 'api';

    this.min = data.min ?? null;
    this.max = data.max ?? null;

    this.idealMin = isApi ? data.ideal_min : data.idealMin ?? null;

    this.idealMax = isApi ? data.ideal_max : data.idealMax ?? null;
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}
